import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import formatCurrency from "helpers/formatCurrency";
import moment from "moment";

export default function getPaymentsTableData(payments) {
  return {
    columns: [
      { Header: "Date", accessor: "date", align: "left" },
      { Header: "Reference", accessor: "reference", align: "left" },
      { Header: "Authorized By", accessor: "authorizer", align: "left", minWidth: "90px" },
      { Header: "Payment", accessor: "payment", align: "right" },
    ],

    rows: payments.map((payment) => {
      return {
        date: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {moment(payment.createdAt).format("YY/MM/DD")}
          </MDTypography>
        ),
        payment: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {formatCurrency(payment.amount)}
          </MDTypography>
        ),
        reference: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {payment.reference}
          </MDTypography>
        ),
        authorizer: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {payment.authorizer.name}
          </MDTypography>
        ),
      };
    }),
  };
}
